import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-month-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'month-switch.component.html',
})
export class MonthSwitchComponent {
  @Input() month: number = new Date().getMonth();
  @Output() monthChange: EventEmitter<number> = new EventEmitter();
  @Output() yearRewind: EventEmitter<number> = new EventEmitter();
  monthsList = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  prevMonth() {
    if (this.month === 0) {
      this.month = 11;
      this.yearRewind.emit(-1);
    } else {
      this.month--;
    }
    this.monthChange.emit(this.month);
  }

  nextMonth() {
    if (this.month === 11) {
      this.month = 0;
      this.yearRewind.emit(1);
    } else {
      this.month++;
    }
    this.monthChange.emit(this.month);
  }

  constructor() {}
}
